import { SvgIcon, SvgIconProps } from '@mui/material';

export const SignatureCheckboxIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <rect
      x="2.5"
      y="2.5"
      width="15"
      height="15"
      rx="2.5"
      stroke="currentColor"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M6.25 10.3125L8.75 12.8125L13.75 7.1875"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
